import React from "react"
import {
  Box,
  Typography,
  TypographyProps,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AccordionDetailsProps,
  AccordionProps,
  AccordionSummaryProps,
  styled,
} from "@mui/material"

const IconArrowDown = styled("svg")(({ theme }) => ({
  width: "17px",
  height: "10px",
  fill: "none",
  "& path": {
    stroke: theme.palette.primary.main,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  },
}))

export const AccordionComponent = styled((props: AccordionProps) => (
  <Accordion disableGutters elevation={0} {...props}>
    {props.children}
  </Accordion>
))(({ theme }) => ({
  border: "none",
  marginBottom: "10px",
  width: "100%",
  "&.MuiAccordion-root": {
    padding: "18px 42px",
    background: theme.palette.common.white,
    boxShadow: "12px 14px 23px rgba(0, 0, 0, 0.03)",
    borderRadius: "26px",
    // Safari browsers
    "@media screen and (-webkit-min-device-pixel-ratio:0)": {
      boxShadow: "none",
    },
    [theme.breakpoints.down("md")]: {
      padding: "8px 21px",
    },
  },
  "&:not(:last-child)": {
    border: "none",
  },
  "&:before": {
    display: "none",
  },
}))

export const AccordionSummaryTitle = styled((props: TypographyProps) => (
  <Typography variant="h5" {...props}>
    {props.children}
  </Typography>
))(({ theme }) => ({
  width: "100%",
  [theme.breakpoints.down("md")]: {
    fontSize: "1rem",
  },
}))

export const Summary = styled((props: AccordionSummaryProps) => (
  <AccordionSummary
    expandIcon={
      <IconArrowDown xmlns="http://www.w3.org/2000/svg">
        <path d="m1 1 7.468 7.503L15.94 1" />
      </IconArrowDown>
    }
    {...props}
  >
    <AccordionSummaryTitle>{props.children}</AccordionSummaryTitle>
  </AccordionSummary>
))(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: 0,
  minHeight: "auto",
  "&.MuiAccordionSummary-content": {
    margin: 0,
  },
}))

export const Details = styled((props: AccordionDetailsProps) => (
  <AccordionDetails {...props}>
    <Box>{props.children}</Box>
  </AccordionDetails>
))(({ theme }) => ({
  padding: 0,
  border: "none",
  [theme.breakpoints.down("md")]: {
    fontSize: "0.825rem",
  },
  "&.MuiAccordionDetails-root": {
    ul: {
      marginLeft: "1rem",
    },
    "li::marker": {
      color: theme.palette.primary.main,
    },
  },
}))

export const Text = styled((props: TypographyProps) => (
  <Typography variant="body1" {...props}>
    {props.children}
  </Typography>
))(() => ({
  margin: "0 0 0.5rem 0",
  width: "100%",
}))
